export function isLoggedIn() {
  return "authToken" in localStorage;
}
